/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="71.12"
        height="91.5"
        viewBox="0 0 71.12 91.5"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#ffb81c"
          d="M1.39 17.11a17.48 17.48 0 0 1 33.06 2.9 1.25 1.25 0 0 1-2.43.58 15 15 0 1 0-15.82 18.4 1.251 1.251 0 0 1-.1 2.5H16A17.51 17.51 0 0 1 0 22.57a17.12 17.12 0 0 1 1.39-5.46Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M28.86 13.69a1.25 1.25 0 0 1 1.63 1.89l-.1.09-7.85 6.05a1.24 1.24 0 0 1-1.74-.22 1.22 1.22 0 0 1 .12-1.66l.1-.09ZM11.94 23.74a1.24 1.24 0 0 1 1.44 1 1.26 1.26 0 0 1-.89 1.45h-.1l-9.71 1.7a1.25 1.25 0 0 1-.55-2.43h.12ZM13.63 28.04a1.25 1.25 0 0 1 2.21 1.15l-.06.12-5 8.39a1.25 1.25 0 0 1-1.71.43 1.26 1.26 0 0 1-.5-1.6l.07-.12ZM4.96 13.44a1.25 1.25 0 0 1 1.65-.25l.11.08 7.41 6.29a1.25 1.25 0 0 1-1.5 2l-.11-.09-7.42-6.3a1.25 1.25 0 0 1-.14-1.73ZM17.63 7.62a1.24 1.24 0 0 1 1.23 1.13v.13l-.09 9.71a1.251 1.251 0 0 1-2.5.11v-.13l.09-9.72a1.23 1.23 0 0 1 1.25-1.23Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#fff"
          d="M21.86 25.17a1.26 1.26 0 0 1 1.28 1.07v.13l1.17 29.44 3.53 6.71a1.16 1.16 0 0 1 .13.37v.13l1.76 26h14.26a1.24 1.24 0 0 1 1.25 1.09v.13a1.24 1.24 0 0 1-1.12 1.24H28.58a1.25 1.25 0 0 1-1.23-1v-.13l-1.83-26.92-3.55-6.73a1.44 1.44 0 0 1-.13-.4v-.13l-1.18-29.72a1.25 1.25 0 0 1 1.2-1.28Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M67.62 25.17a1.25 1.25 0 0 1 1.2 1.17v.13l-1.17 29.7a1.37 1.37 0 0 1-.09.4v.13l-3.55 6.73-1.82 26.89a1.22 1.22 0 0 1-1.11 1.16H43.84a1.25 1.25 0 0 1-.12-2.49h16l1.75-26a1.24 1.24 0 0 1 .09-.38l.06-.12 3.53-6.72 1.16-29.43a1.25 1.25 0 0 1 1.17-1.2Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M66.91 43.61a1.25 1.25 0 0 1 .13 2.49H22.56a1.25 1.25 0 0 1-1.25-1.25 1.27 1.27 0 0 1 1.13-1.25h44.47Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M64.67.08a1.25 1.25 0 0 1 1.26 2.11l-.11.07-12.73 6.62v35.4a1.27 1.27 0 0 1-1.13 1.25h-.12a1.26 1.26 0 0 1-1.25-1.12V8.17a1.25 1.25 0 0 1 .55-1l.12-.07ZM35.62 57.74a1.25 1.25 0 0 1 1.28 1.09v.12l.75 23.51a1.25 1.25 0 0 1-2.48.2v-.12l-.78-23.51a1.26 1.26 0 0 1 1.23-1.29ZM53.85 57.74a1.25 1.25 0 0 1 1.21 1.16v.13l-.75 23.5a1.25 1.25 0 0 1-2.49 0v-.12l.74-23.51a1.26 1.26 0 0 1 1.29-1.16ZM44.74 57.64a1.24 1.24 0 0 1 1.24 1.12v23.71a1.252 1.252 0 0 1-2.5.13V58.89a1.25 1.25 0 0 1 1.25-1.25Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M69.91 25.17a1.25 1.25 0 0 1 .12 2.49H51.96a1.25 1.25 0 0 1-1.25-1.25 1.26 1.26 0 0 1 1.13-1.24Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M51.39 25.17a1.25 1.25 0 0 1 .13 2.49H19.48a1.27 1.27 0 0 1-1.32-1.19 1.25 1.25 0 0 1 1.23-1.3h32Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M38.11 25.17a1.25 1.25 0 0 1 .13 2.44H19.48a1.27 1.27 0 0 1-1.32-1.19 1.25 1.25 0 0 1 1.23-1.25h18.76Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'DrinkingGlassWithStrawAndLemonWheelIcon';

export default Icon;
